module.exports = __webpack_public_path__ + "img/Owens_Entertainment.83a76628.jpg";